module.exports = __webpack_public_path__ + "static/Banshee-613a7769f3b88a2b9c3626f774135516.jpg";